import TreatmentCategoriesInfo from '@/components//templates/telemedicine/category/components/TreatmentCategoriesInfo';
import CustomBreadCrumbs from '@/components/atom/CustomBreadCrumbs';
import TemplateLayout from '@/components/layouts/TemplateLayout';
import DepartmentCategoriesInfo from '@/components/templates/telemedicine/category/components/DepartmentCategoriesInfo';
import { TelemedicineCategoriesViewModel } from '@/hooks/telemedicine/useTelemedicineCategoriesViewModel';
import { DiagnosisCategoryInfoModel } from '@/models/diagnosis/category';
import { ECategoryType } from '@/services/doctor/DiagnosisCategoryService';
import { CustomPageProps } from '@/types/app';
import { ROUTES } from '@/types/common';
import { cn } from '@/utils/style';
import { addQueryString } from '@/utils/url';
import Link from 'next/link';
import React from 'react';

interface Props extends CustomPageProps {
  viewModel: TelemedicineCategoriesViewModel;
}

const renderSelectedCategoryType = (
  selectedCategoryType: ECategoryType,
  categoriesInfo: DiagnosisCategoryInfoModel
) => {
  if (selectedCategoryType === ECategoryType.Treatment) {
    return (
      <TreatmentCategoriesInfo
        popularTreatmentCategories={categoriesInfo.popularTreatmentCategories}
        treatmentCategories={categoriesInfo.treatmentCategories}
      />
    );
  }
  return (
    <DepartmentCategoriesInfo
      departmentCategories={categoriesInfo.departmentCategories}
      popularDepartmentCategories={categoriesInfo.popularDepartmentCategories}
    />
  );
};

const TelemedicineCategoriesTemplate = (props: Props) => {
  const { client, viewModel } = props;
  return (
    <TemplateLayout.Wrapper>
      {!client.isMobile && (
        <CustomBreadCrumbs.Wrapper>
          <CustomBreadCrumbs breadCrumbs={viewModel.breadCrumbs} visible />
        </CustomBreadCrumbs.Wrapper>
      )}
      <TemplateLayout.Content>
        <h1 className={'typography-ui-22sb flex h-[60px] items-center pr-[20px] pl-[24px] text-gray-900'}>
          증상/과목 선택
        </h1>
        <ul className={'flex h-[44px] w-full items-center border-gray-50 border-b-[1px] border-solid px-[16px]'}>
          {viewModel.tabs.map((tab) => {
            return (
              <li
                key={tab.label}
                className={cn([
                  'relative flex h-full flex-1 items-center',
                  {
                    'before:absolute before:bottom-0 before:left-[8px] before:h-[2px] before:w-[calc(100%-16px)] before:bg-gray-800 before:opacity-0 before:transition-opacity before:duration-300 before:content-[""]': true,
                    'before:opacity-100': viewModel.selectedCategoryType === tab.type,
                  },
                ])}
              >
                <Link
                  href={
                    ROUTES.TELEMEDICINE.CATEGORIES.path +
                    addQueryString({
                      type: tab.type,
                    })
                  }
                >
                  <a
                    className={cn([
                      'flex h-full w-full items-center justify-center',
                      {
                        'typography-ui-15sb text-gray-800': viewModel.selectedCategoryType === tab.type,
                        'typography-ui-15m text-gray-400': viewModel.selectedCategoryType !== tab.type,
                      },
                    ])}
                  >
                    {tab.label}
                  </a>
                </Link>
              </li>
            );
          })}
        </ul>
        {renderSelectedCategoryType(viewModel.selectedCategoryType, viewModel.categoriesInfo)}
      </TemplateLayout.Content>
    </TemplateLayout.Wrapper>
  );
};

export default TelemedicineCategoriesTemplate;
